import { createApi } from "@reduxjs/toolkit/query/react";

import { CourseSelectionMode } from "@/pages/awareness/progress/certificate_export/CertificateExportSlice";
import { learningBaseQuery } from "@/utils/rtkQuery";

type ExportId = {
  value: string;
};

type ExportCompany = {
  name: string;
  id: number;
};

type ArchiveLink = {
  url: string;
};

type ArchiveLocation = {
  name: string;
  folder: string;
};

type GetExportBatchInfoResponse = {
  info: ExportBatchInfo[];
};

export type ExportBatchInfo = {
  status: "done" | "to_do" | "nothing_to_certify";
  export_id: ExportId;
  sequence_number: number;
  company: ExportCompany;
  export_date: string;
  archive_link: ArchiveLink | null;
  archive_location: ArchiveLocation | null;
};

export const certificatesApi = createApi({
  reducerPath: "certificatesApi",
  baseQuery: learningBaseQuery(),
  endpoints: (builder) => ({
    startCertificateExport: builder.mutation({
      query: (payload: {
        usersToExportAdresses: string[];
        departementsToExportIds: number[];
        audienceType: string;
        course_selection_mode: CourseSelectionMode;
        selected_course_ids: number[];
      }) => ({
        url: `certificates/export/`,
        method: "POST",
        body: {
          users_to_export_adresses: payload.usersToExportAdresses,
          departments_to_export_ids: payload.departementsToExportIds,
          audience_type: payload.audienceType,
          course_selection_type: payload.course_selection_mode,
          selected_course_ids: payload.selected_course_ids,
        },
      }),
    }),
    getCompanyExportBatches: builder.query<GetExportBatchInfoResponse, number>({
      query: () => `certificates/get/`,
    }),
  }),
});

export const {
  useStartCertificateExportMutation,
  useGetCompanyExportBatchesQuery,
} = certificatesApi;
